module.exports = __webpack_public_path__ + "img/position_hover.91bba9a4.svg";